/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RemoveItemFromInventory$Params {
  itemId: string;
      body?: {
'type': 'sold' | 'lost' | 'stolen' | 'destroyed' | 'donated';
'date'?: string | null;
'note'?: string | null;
}
}

export function removeItemFromInventory(http: HttpClient, rootUrl: string, params: RemoveItemFromInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, removeItemFromInventory.PATH, 'post');
  if (params) {
    rb.query('itemId', params.itemId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

removeItemFromInventory.PATH = '/admin/items/remove';
